
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const cityApi = createAsyncThunk("city", async () => {
  const response = await axiosInstance.get("/city");
  return response.data;
});

const citySlice = createSlice({
  name: "city",
  initialState: {
    city: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(cityApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(cityApi.fulfilled, (state, action) => {
        state.city = action.payload;
        state.loading = false;
      })
      .addCase(cityApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default citySlice.reducer;
